import React from 'react';
import { Box } from '@mui/material';
import Footer from './footer';
import Header from './header';

interface LayoutProps {
  children?: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <Box
        component="a"
        href="#main-content"
        sx={{
          position: 'absolute',
          top: '-40px',
          left: 0,
          background: '#000',
          color: '#fff',
          padding: '8px 16px',
          zIndex: 100000,
          textDecoration: 'none',
          '&:focus': {
            top: 0,
          },
        }}
      >
        Skip to main content
      </Box>
      <Header />
      <Box component="main" id="main-content" tabIndex={-1} sx={{ outline: 'none' }}>
        {children}
      </Box>
      <Footer />
    </>
  )
}

export default Layout
